import PageManager from '../page-manager';

export default class Home extends PageManager {}



// WEBPACK FOOTER //
// ./assets/js/theme/home.js